
import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from '../navbar/Navbar';
import "./logo.css";
import Formpage from '../Formpage/Formpage';
import AOS from 'aos';
import 'aos/dist/aos.css';

  const items = [
    {
      title: 'BASIC LOGO',
      description: [
        '1 Initial Concept',
        '1 Revision',
        'Basic Typography or Icon-Based Design',
        'Delivery in JPG & PNG (non-vector)',
        'Turnaround: 2–3 Days',
      ],
      img: 2,
    },
    {
      title: 'STANDARD LOGO',
      description: [
        '2–3 Logo Concepts',
        '3 Revisions',
        'Custom Font & Color Options',
        'Files in JPG, PNG, and PDF',
        'Transparent & High-Res Versions',
        'Turnaround: 3–5 Days',
      ],
      img: 3,
    },
    {
      title: 'PROFESSIONAL LOGO',
      description: [
        '3–4 Creative Concepts',
        '5+ Revisions',
        'Vector Files (AI, EPS, SVG, PDF)',
        'Color & B/W Versions',
        'Favicon Design',
        'Brand Guide (Fonts & Colors)',
        'Turnaround: 5–7 Days',
      ],
      img: 4,
    },
    {
      title: 'PREMIUM LOGO',
      description: [
        '4–6 Logo Concepts',
        'Unlimited Revisions',
        'Complete Brand Kit:',
        '→ Logo Variations',
        '→ Typography Guide',
        '→ Color Palette',
        '→ Brand Usage Guide',
        'Mockups (Stationery, Social Media, etc.)',
        'Social Media Profile Kits',
        'Delivery: 7–10 Days',
      ],
      img: 5,
    },
    {
      title: 'ADD-ONS',
      description: [
        'Business Card Design',
        'Letterhead/Envelope',
        'Social Media Kit',
        'Logo Animation',
        'Brand Guidelines Booklet',
        'Additional Concepts',
      ],
      img: 2,
    },
  ];
function Logo() {
      const [show, setShow] = useState(false);
      const handleShow = () => setShow(true);
      const handleClose = () => setShow(false);
 const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  centerMode: true,
  centerPadding: '0px',
  arrows: true,
  initialSlide: 0,

  responsive: [
    {
      breakpoint: 992, // tablet and below
      settings: {
        slidesToShow: 2,
        arrows: false,
        centerMode: false
      }
    },
    {
      breakpoint: 576, // mobile
      settings: {
        slidesToShow: 1,
        arrows: false,
        centerMode: false
      }
    }
  ]
};

  useEffect(() => {
      AOS.init({
        duration: 1000,
        once: true,
      });
  
      setTimeout(() => {
        AOS.refresh();
      }, 500);
    }, []);



    return (
        <>
            <Navbar />
            <div className="container-fluid web-container" >
                <div className="wrapper">
                   <section className='section-margin'>
                        <center>
                            <div className='heading-for-all' data-aos="fade-up">
                                <h2>logo</h2>
                            </div>
                        </center>
                    </section>

                    <Slider {...settings} className="news-slider">
                        {items.map((item, index) => (
                            <div className="news-slider__item" key={index}>
                                <div className="news__item news__item2" data-aos="fade-up"
                                data-aos-delay="1000" >
                                    <div className="news__title">{item.title}</div>
                                    <ul className="news__txt">
                                        {item.description.map((point, idx) => (
                                            <li key={idx}>{point}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </Slider>

                </div>
         
            <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleShow}>
                        Get Enquiry
                    </button>
                </div>
         </div>

      <Formpage show={show} onClose={handleClose} />
        </>
    );
}

export default Logo;

